<template>
  <div class="subtask-filter-pane">
    <div v-if="fastSubtaskStats.length" class="status-pane custom-scroll x-scroll">
      <el-tooltip
        v-for="status in fastSubtaskStats"
        :key="status.name"
        :content="status.title"
        :open-delay="500">
        <div
          class="status-item"
          :class="{active: activeStatus && activeStatus.name === status.name}"
          @click="handleStatusClick(status)">
          <div class="status-item_count" :class="status.name + '-before bordered'">
            <span>{{ status.count }}</span>
          </div>
        </div>
      </el-tooltip>
    </div>
    <el-popover :width="226">
      <template #reference>
        <div class="stats-btn" :class="markClass">
          <i class="fa fa-pie-chart"/>
        </div>
      </template>
      <div v-loading="loading" class="status-popover">
        <div class="list-title">
          Статусы подзадач
        </div>
        <div v-if="!loading && !subtaskStats.length" class="stats-empty-dummy">
          Данные отсутствуют
        </div>
        <div v-else class="status-list">
          <div v-for="status in subtaskStats" :key="status.name" class="status-list-item">
            <div
              class="status-pin-icon"
              :class="{ pinned: checkPinned(status.name) }"
              @click="toggleFastStatus(status.name)">
              <i class="fa fa-thumb-tack"/>
            </div>
            <div
              class="status-info"
              :class="{active: activeStatus && activeStatus.name === status.name}"
              @click="handleStatusClick(status)">
              <div class="status-title" :class="status.name + '-before'">
                {{ status.title }}
              </div>
              <div class="status-count">
                {{ status.count }}
              </div>
            </div>
          </div>
        </div>
        <div v-if="!loading" class="stats-refresh-btn" @click="handleRefreshBtnClick">
          Обновить
        </div>
      </div>
    </el-popover>
  </div>
</template>

<script>
import { ElPopover, ElTooltip } from 'element-plus'
import '@/assets/sass/style/subtaskStatusFilterPane.scss'
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'SubtaskStatusFilterPane',
  components: {
    ElPopover,
    ElTooltip
  },
  data: () => ({
    loading: false,
    activeStatus: undefined
  }),
  computed: {
    ...mapGetters(['subtaskFilterValue']),
    ...mapGetters({
      subtaskStats: 'creator/subtaskStats',
      fastSubtaskStats: 'creator/fastSubtaskStats',
      subtaskStatusFilter: 'creator/subtaskStatusFilter'
    }),
    showActiveMark() {
      return this.activeStatus && this.fastSubtaskStats.every(item => item.name !== this.activeStatus.name)
    },
    markClass() {
      if (!this.showActiveMark) return
      return this.activeStatus.name + '-before bordered'
    }
  },
  watch: {
    activeStatus(value) {
      if (!value) {
        this.resetFilter('subtaskStatus')
        this.updateListResponseId()
        return
      }
      this.setFilterValue({
        name: 'subtaskStatus',
        label: value.title
      })
    },
    subtaskFilterValue(value) {
      if (value) return
      this.activeStatus = undefined
    }
  },
  methods: {
    ...mapMutations(['supplementFilter', 'setFilterValue', 'resetFilter', 'updateListResponseId']),
    ...mapMutations({
      setSubtaskStats: 'creator/setSubtaskStats',
      toggleFastStatus: 'creator/toggleFastStatus'
    }),
    ...mapActions({
      downloadSubtaskStatsForApps: 'creator/downloadSubtaskStatsForApps'
    }),
    checkPinned(name) {
      return this.fastSubtaskStats.some(item => item.name === name)
    },
    handleStatusClick(status) {
      const alreadyActive = this.activeStatus && status.name === this.activeStatus.name
      this.activeStatus = alreadyActive ? undefined : status
    },
    async handleRefreshBtnClick() {
      this.loading = true
      await this.downloadSubtaskStatsForApps()
      this.loading = false
    }
  },
  async beforeMount() {
    this.loading = true
    await this.downloadSubtaskStatsForApps()
    this.supplementFilter(this.subtaskStatusFilter)
    this.loading = false
  },
  beforeUnmount() {
    this.setSubtaskStats()
  }
}
</script>

<style scoped>

</style>
